import { inject, injectable } from 'inversify'
import { RequestHandler, requestHandler } from 'mediatr-ts'

import { SessionManager } from '@infrastructure/managers/session/session-manager'

import { RefreshOverleafStatusCommand } from './command'

@requestHandler(RefreshOverleafStatusCommand)
@injectable()
export class RefreshOverleafStatusCommandHandler
  implements RequestHandler<RefreshOverleafStatusCommand, void>
{
  constructor(@inject(SessionManager) private readonly sessionManager: SessionManager) {}

  public async handle(): Promise<void> {
    await this.sessionManager.refreshOverleafStatus()
  }
}
